import React, { useState, useEffect } from 'react';
import { Container, Carousel } from 'react-bootstrap';
import { apiUrl } from '../apiUrl';

interface Testimonial {
  id: number;
  name: string;
  text: string;
  created_at: string;
  updated_at: string;
}

interface TestimonialSectionProps {
  variant?: 'carousel' | 'stories';
  showHeading?: boolean;
}

const TestimonialSection: React.FC<TestimonialSectionProps> = ({ variant = 'carousel', showHeading = true }) => {
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);
  const [storiesStatus, setStoriesStatus] = useState<'loading' | 'loaded' | 'error'>('loading');

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await fetch(apiUrl('/api/testimonials'));
        if (!res.ok) throw new Error('Failed to fetch testimonials');
        const data: Testimonial[] = await res.json();
        setTestimonials(data);
        setStoriesStatus('loaded');
      } catch (err) {
        console.error('Error fetching testimonials:', err);
        setStoriesStatus('error');
      }
    };
    fetchTestimonials();
  }, []);

  return (
    <section className={variant === 'stories' ? 'tw-m-0 tw-bg-transparent tw-p-0' : 'testimonial-section py-5'}>
      <Container className={variant === 'stories' ? 'tw-max-w-none tw-p-0' : undefined}>
        {showHeading && <h2 className="text-center mb-5 section-title">What People Say</h2>}
        {variant === 'stories' ? (
          storiesStatus === 'loading' ? (
            <p role="status">Loading stories…</p>
          ) : storiesStatus === 'error' ? (
            <p role="status">Stories are currently unavailable. Please try again later.</p>
          ) : testimonials.length > 0 ? (
            <div className="tw-grid tw-grid-cols-1 tw-gap-4 min-[641px]:tw-grid-cols-2 lg:tw-grid-cols-3">
              {testimonials.map((testimonial) => (
                <article className="sf-story-card tw-h-full" key={testimonial.id}>
                  <p>“{testimonial.text}”</p>
                  <strong>— {testimonial.name}</strong>
                </article>
              ))}
            </div>
          ) : (
            <p role="status">No stories are available yet.</p>
          )
        ) : testimonials.length > 0 ? (
          <Carousel indicators={true} controls={true} interval={3000} pause="hover">
            {testimonials.map((testimonial) => (
              <Carousel.Item key={testimonial.id}>
                <div className="testimonial-box text-center fade-in-up">
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <h4 className="testimonial-name">- {testimonial.name}</h4>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <p className="text-center">No testimonials available.</p>
        )}
      </Container>
    </section>
  );
};

export default TestimonialSection;
